// This callback is used for `display: "page"` oauth flows only
import OauthLoginCallback from 'app/components/auth/OauthLoginCallback';
export default OauthLoginCallback;
